import { ReactNode } from 'react';

import { App, ConfigProvider, theme } from 'antd';
import ruRu from 'antd/lib/locale/ru_RU';
import { useAppSelector } from 'services/redux/configureStore';

interface AntdProviderProps {
  children: ReactNode;
}

const AntdProvider = ({ children }: AntdProviderProps) => {
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const isDarkMode = useAppSelector((state) => state.theme.isDarkMode);

  return (
    <ConfigProvider
      locale={ruRu}
      theme={{
        algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
        token: { screenLGMax: 1050, screenXL: 1051, screenXLMin: 1051 },
      }}
    >
      <App>{children}</App>
    </ConfigProvider>
  );
};

export default AntdProvider;
